import httpClient from "@/config/axios";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { useGroupSelection } from "./useGroupSelection";

export interface AvailableMember {
  account_id: string;
  big_kind_name: string;
  birth_date: string;
  career: string;
  duty: string;
  emp_num: string;
  gender: string;
  is_head_nurse: string;
  joining_date: string;
  mb_part_name: string;
  middle_kind_name: string;
  name: string;
  nurse_id: string;
  phone_number: string;
  small_kind_name: string;
}

/**
 * 이거 쓰시면돼요
 * 이 엔드포인트는 수간호사라도 Group Id 넘겨야해요
 */
export default function useAvailableMember(
) {
  const { selectedGroupId } = useGroupSelection();

  console.log("selectedGroupId", selectedGroupId);


  return useQuery<AvailableMember[]>({
    queryKey: ["AVAILABLE-MEMBER", selectedGroupId],
    queryFn: async () => {
      return await httpClient.get<AvailableMember[]>(
        "/nurses/available-members",
        { params: { group_id: selectedGroupId } }
      );
    },
    enabled: !!selectedGroupId,
    retryOnMount: false
  });
}
